import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MODULE_SERVICE_NAME,
  PolarJServerModelContextPath,
} from '../constants';
import { CountryNameMap, PagingData } from '../models';
import { CityStateZip } from '../models/address.model';
import { PolarJService } from './polarj.service';

@Injectable({
  providedIn: 'root',
})
export class GlobaldataService {
  private _polarjService: PolarJService = inject(PolarJService);

  fetchCityByZipcode(zipcode: string): Observable<PagingData<CityStateZip>> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.GLOBALDATA,
      modelName: PolarJServerModelContextPath.CITY_STATE_ZIPS,
      requestMappingString: 'byZip/' + zipcode,
      enableErrorMsg: true,
      singleData: false,
      pageData: true,
    });
  }

  fetchCityStatesByCountryName(
    countryName: string
  ): Observable<PagingData<CityStateZip>> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.GLOBALDATA,
      modelName: PolarJServerModelContextPath.CITY_STATE_ZIPS,
      requestMappingString: countryName + '/states',
      enableErrorMsg: true,
      singleData: false,
      pageData: true,
    });
  }

  // globaldata/citystatezips/countries
  fetchCountries(): Observable<PagingData<CountryNameMap>> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.GLOBALDATA,
      modelName: PolarJServerModelContextPath.CITY_STATE_ZIPS,
      requestMappingString: 'countries',
      enableErrorMsg: true,
      singleData: false,
      pageData: true,
    });
  }
}
